import { z } from "zod";
/**
 * `GET /health` (block 00c).
 *
 * Lives here rather than in the backend because `@nook/schema` is the single
 * source of truth for request/response shapes and both sides import it
 * (plan §2). Block 00e's `useHealth()` parses the response with this schema;
 * the backend's route returns a value typed by it. Neither hand-maintains a
 * copy.
 *
 * `build` is the git SHA the running image was built from. It is deliberately
 * the only field beyond `ok`: the endpoint is unauthenticated so that Fly's
 * health checks and an external uptime monitor can hit it without credentials
 * (plan §13.5), which means it must never expose user or plan data (ISP).
 */
export const healthResponseSchema = z.object({
    ok: z.literal(true),
    build: z.string(),
});
//# sourceMappingURL=health.js.map